import React ,{Component} from 'react';
import IconButton from '@mui/material/IconButton';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/system'; 
import InputLabel from '@mui/material/InputLabel';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import {NavLink, Navigate  } from 'react-router-dom';
import axios from 'axios';
import AddIcon from '@mui/icons-material/Add';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Select from '@mui/material/Select';
//import { styled } from '@mui/material/styles';
import Autocomplete from '@mui/material/Autocomplete';
import EditIcon from '@mui/icons-material/Edit';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import Table from '@mui/material/Table';
import TableRow from '@mui/material/TableRow'; 
import Paper from '@mui/material/Paper';  
import InputAdornment from '@mui/material/InputAdornment';
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import DeleteIcon from '@mui/icons-material/Delete';
import Tooltip from '@mui/material/Tooltip';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import dayjs from 'dayjs';
import SearchOutlinedIcon from '@mui/icons-material/SearchOutlined';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import Checkbox from '@mui/material/Checkbox';
import AddLedger from './AddLedger';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import AttachmentIcon from '@mui/icons-material/Attachment';


import ContentCopyTwoToneIcon from '@mui/icons-material/ContentCopyTwoTone';

let strLedger=[{title:'Add Ledger',year:'0',rowindex:'-1'}];
const strProduct=[];
const strProductdeflt='';
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };
const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});
export default class AddJournal extends Component {
constructor(props) {
    super();
	
	  var strdob=new Date();
	 var month="";
	
	 if((strdob.getMonth() + 1)<10)
	 {
		month="0"+ (strdob.getMonth() + 1)		 
	 }else{month=(strdob.getMonth() + 1)}
	 
	  var strgoods=new Date();
   strgoods.setDate(strgoods.getDate() + 3);
   
	 this.state = {
		 jo_date:Date.now(),jo_date1:strdob.getFullYear() + '-' + month + '-' +strdob.getDate(),
		 
		 copyest:"0",submitbtn:'Save',previocn:'',jo_id:0,jo_reference:'',jo_description:'',btndisabled:false
		 ,open:false,erropen:false,errormessage:'',errortype:"error",redirect:false,
		showField:-1,newpcid:0,lederarrauto:[],leid:'',selectedproduct:[],prodrowindex:0,pvdata:[],ledgerarray:[],
		jo_file:'',textcountmin:0,ind:0,
textcountmax:200,
}
 this.updatledgerParent = this.updatledgerParent;

}

updatledgerParent = (childData) => {
    this.setState({ leid: childData });

 
    const strvalues = childData;
    const strind = this.state.ind;
    const strarrvalues = strvalues.split('~');

    const updatedArrays = this.state.pvdata.slice();  
	updatedArrays[strind] = {
        ...updatedArrays[strind], 
        le_id: strarrvalues[0],  
        ledgername: strarrvalues[1], 
    };

    this.setState({pvdata:updatedArrays },()=>{
});
		
};
myChangeHandler = (event) => {
    let nam = event.target.name;
    let val = event.target.value;

    
    if (nam === 'jo_description') {
       
        if (val.length <= this.state.textcountmax) {
            this.setState({
                [nam]:val,           
                textcountmin:val.length 
            });
        }
    } else {
       
        this.setState({ [nam]: val });
    }
};
componentWillMount() {
	document.title = "Isifol Account - Journals";
if(localStorage.getItem("ISIuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
else
{	
if(localStorage.getItem("ISIrole")==="1" || localStorage.getItem("ISIrole")==="2")
		  {
			
		  }
		  else{
	    
		this.PageAccessCheckApi();
		  }
	}
		   let strname="";
		   
	 this.props.parentdasCallback(
            "Journals~"
        ); 

 let search = window.location.href;
 let Joid = this.getParameterByName('joid', search);
	   
		  let copyest = this.getParameterByName('copy', search);
		  if(copyest!==null)
		{this.setState({copyest:copyest});
			
		}
				if(Joid!==null)
		{
		this.GetJournaldataByID(Joid)
		}
		
		else{
			this.JournalLedegerPayment();
		}
}
 onclickCancel = (e) => {
	this.setState({redirect:true,pagename:'/Adminjournals'});
 }
   getParameterByName(name, url) {
    if (!url) url = window.location.href;
    url = url.toLowerCase(); 
    name = name.replace(/[\[\]]/g, "\\$&").toLowerCase();
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
}

PageAccessCheckApi() {
	
  axios.get(localStorage.getItem("ISIurl")+'ajaxpagemaster.php?action=getbyuser&us_id='+localStorage.getItem('ISIuserid')+'&up_pm_id=11')
  
  .then(resp => {	  
	  
	  let strreturn=resp.data;

      if (strreturn!==0) {
       
        
      } else {
       
        this.setState({redirect: true,pagename: "/Accesspagemessage"});
      }
    
  });
}
GetJournaldataByID(Joid) {
    axios.get(localStorage.getItem("ISIurl") + 'ajaxjournal.php?action=getall&jo_cmp_id='+localStorage.getItem("ISIcmpid")+'&jo_id=' + Joid)
        .then(resp => {
     
                this.setState({
					jo_reference:resp.data[0].jo_reference,
					jo_description:resp.data[0].jo_description,
					jo_date:resp.data[0].jo_date,
					jo_date1:resp.data[0].devdate,
					jo_id:resp.data[0].jo_id,
				
				 },()=>{
				});
			this.JournalRefereGetAll(Joid); 
           
        });

}


JournalRefereGetAll(joid){
	axios.get(localStorage.getItem("ISIurl")+'ajaxjournal.php?action=journaldetails&sorting=jr_id&jr_jo_id='+joid)
     
  .then(resp => { 
let oldOptionspvdata=[]; 

let newrow= {
	"rowindex": resp.data.length,"jr_id":"0","le_id":"","jr_le_id":"","jr_details":"","jr_debit":"","jr_credit":"","jr_jo_id":"0","jr_isdeleted":"0","ledgername":[],showField: resp.data.length,}
	

    if(resp.data.length>0){
		
			
			  oldOptionspvdata=resp.data
			 
			  let index=0;
			  oldOptionspvdata.forEach(eachrep => {
				
					eachrep.rowindex=index;
					eachrep.ledgername={"title":eachrep.le_displayname,"year":eachrep.le_id};
index++;
				});
		
		}	

	  this.setState({pvdata: oldOptionspvdata.concat([newrow])},()=>{;

	 
	  });
  
  
    });
	
}
JournalLedegerPayment() {
	 
	
	   this.setState({ 
	 pvdata: [{"rowindex":this.state.newpcid,"jr_id":"0","le_id":"","jr_le_id":"","jr_details":"","jr_debit":"","jr_credit":"","jr_jo_id":"0","jr_isdeleted":"0","ledgername":[],showField: this.state.newpcid,}],},()=>{
			 
	 });  
 }


   handlejournaldate= (date) => {
    var month = "";
    var dateObj = new Date(date);

       if ((dateObj.getMonth() + 1) < 10) {
        month = "0" + (dateObj.getMonth() + 1);
    } else {
        month = (dateObj.getMonth() + 1);
    }

 this.setState({
        jo_date:dayjs(dateObj),
        jo_date1:dateObj.getFullYear() + '-' + month + '-' + dateObj.getDate()
    });
  }
  
  handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  }
  
   onFileChange=(e) =>{   	 
	   
	
	 let imageFile = e.target.files[0];
	 let size = e.target.files[0].size;
   if (!imageFile.name.match(/\.(png|jpeg|jpg|doc|pdf|docx)$/)) {

  this.setState({errormessage:"Please Upload File (png,jpeg,jpg,doc,pdf,docx).",erropen:true});
		 window.scrollTo({        top: 0     })
	
  
    return false;
  }else{
        this.setState({ jo_file: e.target.files })
  }
	
		
    }
  onClickSalesSave = (event) => {
	  
 let optionsVal = this.state.pvdata;
    let srearray = optionsVal.filter(value => value.jr_isdeleted < 1);
	let optionValues = "", sep1 = "";

 
    if (this.state.jo_reference === "") {
        this.setState({ errormessage: "Please Enter Reference", erropen: true });
        window.scrollTo({ top: 0 });
        return false;
    }

 
   	 if(srearray.length === 1)	
		{
	 this.setState({errormessage:"Please Select journal payment ",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
		}
		
	 if(optionsVal.length === 1)
	 {
		
		 this.setState({errormessage:"Your Journal amount is 0 please add debit or credit ",erropen:true,});
		 window.scrollTo({ top: 0})
		 return false;
	 }
	     
    this.setState({ btndisabled: true, submitbtn: "Processing..." });

    let formData = new FormData();
    formData.append('action', 'insertorupdate');
   
    if (this.state.jo_file !== "") {
        for (const key of Object.keys(this.state.jo_file)) {
            formData.append('Filedata', this.state.jo_file[key]);
        }
        formData.append('jo_file', '1');
    } else {
        formData.append('jo_file', this.state.previocn);
    }

    
    if (this.state.copyest === "1") {
        formData.append('jo_id', 0);
    } else {
        formData.append('jo_id', this.state.jo_id);
    }
    
    optionsVal.forEach(eachval => {
        if (eachval.le_id !== "0" && eachval.le_id !== "") {
			
			
            optionValues = optionValues + sep1 + eachval.le_id + "~" + eachval.jr_details + "~" + eachval.jr_debit + "~" + eachval.jr_credit + "~" + eachval.jr_jo_id;
            sep1 = "`";
        }
    });
    
    formData.append('jo_reference', this.state.jo_reference);
    formData.append('jo_date', this.state.jo_date1);
    formData.append('jo_description', this.state.jo_description);
    formData.append('journalledgerpayment', optionValues);
    formData.append('journalledgerdelete', '');
    formData.append('userid', localStorage.getItem("ISIuserid"));
    
	   formData.append('jo_cmp_id', localStorage.getItem("ISIcmpid"));
    axios.post(localStorage.getItem("ISIurl") + "ajaxjournal.php", formData)
        .then(res => {
            if (this.state.jo_id === 0) {
                this.setState({ 
				jo_date1:'',jo_description:'',jo_reference:'',
				jr_debit:'',jr_credit:'',jr_details:'',pvdata: [], btndisabled: false, submitbtn: "Save", errortype: "success", errormessage: "Journal created Successfully", erropen: true });
            } else if (this.state.copyest === "1") {
                this.setState({ 
				jr_debit:'',jr_credit:'',jr_details:'',
				jo_date1:'',jo_description:'',jo_reference:'',
				pvdata: [], btndisabled: false, submitbtn: "Save",redirect:true,pagename:'/Adminjournals', errortype: "success", errormessage: "Journal created Successfully", erropen: true });
            } else {
                 this.setState({ 
				jo_date1:'',jo_description:'',jo_reference:'',
				jr_debit:'',jr_credit:'',jr_details:'',pvdata: [], btndisabled: false, submitbtn: "Save", errortype: "success", errormessage: "Journal Update Successfully", erropen: true });
            }
						
			 this.JournalLedegerPayment();
		})
	};


myChangeHandlerPV = (firstrow) => (event) => {
    const re = /^[0-9\.]+$/; 
    const nam = event.target.name; 
    const val = event.target.value; 

    let updatedArray = [...this.state.pvdata]; 

    const currentDebit = updatedArray[firstrow].jr_debit;
    const currentCredit = updatedArray[firstrow].jr_credit;

    if (nam === "jr_debit") {
        if (currentCredit!=="" && currentCredit!=="0") {
         this.setState({errormessage:"You cannot enter Debit when Credit is already entered ",erropen:true,});
		 window.scrollTo({top: 0})
		 return false;
        }
        if (val === '' || re.test(val)) {
            updatedArray[firstrow].jr_debit = val; 
        }
    }

    if (nam === "jr_credit") {
        if (currentDebit!==""  && currentDebit!=="0") {
           this.setState({errormessage:"You cannot enter credit when debit is already entered ",erropen:true,});
		 window.scrollTo({ top: 0})
		 return false;
        }
        if (val === '' || re.test(val)) {
            updatedArray[firstrow].jr_credit = val;
        }
    }

    if (nam === "jr_details") {
        updatedArray[firstrow].jr_details = val;
    }

    this.setState({ pvdata: updatedArray });
};



 Ledgeraddbox= (rowindex) =>{
	  this.setState({ind:rowindex},()=>{this.refs.AddLedger.handleClickOpen()});  
 }
	  


 onInputLedgerChange = (rows) =>(event, newTextValue) => {
  
	if(newTextValue!==" "){
		const updatedArray = [...this.state.pvdata];

	updatedArray[rows].jr_le_id = newTextValue;
  this.setState({pvdata:updatedArray})
	  
	} 

 }


 /*onTagsledgerChange =(index) => (event, values) => {
	let id = index;

	if(values.rowindex!=="-1" && values!==null)
	{
	let optionsRep = this.state.pvdata;
optionsRep.sort((a, b) => a.rowindex > b.rowindex ? 1 : -1).forEach(eachrep => {
		
       if (eachrep.rowindex === id)
	   {
		  eachrep.ledgername = values;
        eachrep.jr_le_id = values["year"];
        eachrep.le_id = values["year"];
		   
	   }
		
   });
   
id=parseInt(this.state.pvdata.length);
let prevrow=parseInt(this.state.pvdata.length)-1;

if(this.state.pvdata[prevrow].le_id!=="")
{
this.setState({pvdata:optionsRep.concat([{"rowindex":id,"jr_id":"0","le_id":"","jr_le_id":"0","jr_details":"","jr_debit":"","jr_credit":"","jr_isdeleted":"0","ledgername":[],showField: id,}]), },()=>{

console.log(this.state.pvdata)
});
}
	 }	
 
 }*/
onTagsledgerChange = (index) => (event, values) => {
  if (!values || values.rowindex === "-1") return;

  let updatedPvData = [...this.state.pvdata];

  updatedPvData[index] = {
    ...updatedPvData[index],
    ledgername: values,
    jr_le_id: values.year,
    le_id: values.year,
  };

 
  const isLastRow = index === updatedPvData.length - 1;
  const lastRowFilled = updatedPvData[index].le_id !== "";

  if (isLastRow && lastRowFilled) {
    const newRowIndex = updatedPvData.length;
    updatedPvData.push({
      rowindex: newRowIndex,
      jr_id: "0",
      le_id: "",
      jr_le_id: "0",
      jr_details: "",
      jr_debit: "",
      jr_credit: "",
	  jr_jo_id:"0",
      jr_isdeleted: "0",
      ledgername: [],
      showField: newRowIndex,
    });
  }

  this.setState({ pvdata: updatedPvData });
};
/*OnrowAddLedger = (index) => {
	

  
let id = index;
let optionsRep = this.state.pvdata;

		   this.state.pvdata.splice(id, 0, {"rowindex":id-1,"jr_id":"0","le_id":"","jr_le_id":"0","jr_details":"","jr_debit":"","jr_credit":"","jr_isdeleted":"0","ledgername":[],showField: id-1});
this.setState({pvdata:this.state.pvdata},()=>{




});
}*/
OnrowAddLedger = (index) => {
  const currentData = [...this.state.pvdata];
  
  const newRow = {
    rowindex: 0,jr_id: "0",le_id: "",jr_le_id: "0",jr_details: "",jr_debit: "",jr_credit: "",jr_jo_id:"0",
    jr_isdeleted: "0",ledgername: [],showField: 0};
  currentData.splice(index, 0, newRow);  
  const updatedData = currentData.map((row, i) => ({
    ...row,
    rowindex: i,
    showField: i
  }));

  this.setState({ pvdata: updatedData });
};


LedgerBind=(event)=>{
	 	
axios.get(localStorage.getItem("ISIurl")+'ajaxledger.php?action=ledgerautoextender&le_cmp_id='+localStorage.getItem("ISIcmpid")+'&le_journal=1&le_displayname='+event.target.value)
  .then(resp => { 
 
  
  if(resp.data.length>0){
  this.setState({ledgerarray:resp.data });
   var rowsArrayp = resp.data;
 
	 rowsArrayp.map((row, j) => {
		
		 
		 const items = {
			 
        title:row.le_code +" - "+row.title,
        year:row.year,
		rowindex:row.rowindex,
		
        
        };
	
      const found = strLedger.some(el => el.year === row.year);
		 if (!found) strLedger.push(items);
	 
		 });
		   this.setState({lederarrauto:strLedger})
  } 
  
  
  });
 
	
}

/*onRowCopyLedger=(rowsval)  => event  =>{
	  let id = rowsval;
  let optionsRep1 = this.state.pvdata; 

  let ledgername="", jr_le_id=0, jr_debit=0, jr_details="", addpopupicon, jr_credit=0;
      optionsRep1.forEach(eachrep => {
	
      if (eachrep.rowindex === rowsval) {

      ledgername = eachrep.ledgername;
      jr_le_id = eachrep.jr_le_id;
      jr_debit = eachrep.jr_debit;
      jr_details = eachrep.jr_details;
      addpopupicon = eachrep.addpopupicon;
      jr_credit = eachrep.jr_credit;

     id = parseInt(this.state.pvdata.length) ; 
	
		this.setState({pvdata:optionsRep1.concat([{"rowindex":id,"jr_id":"0","jr_le_id":jr_le_id,"jr_details":jr_details,"jr_debit":eachrep.jr_debit,"jr_credit":eachrep.jr_credit,"jr_isdeleted":"0","ledgername":ledgername,showField:id,}])});
    } 
});
	 }
*/
onRowCopyLedger = (rowIndexToCopy) => {
  const currentRows = [...this.state.pvdata];  
  const arrayIndex = currentRows.findIndex(row => row.rowindex === rowIndexToCopy);

  if (arrayIndex === -1) {
    alert("Row to copy not found at index: " + rowIndexToCopy);
    return;
  }

  const rowToCopy = currentRows[arrayIndex];

  const newRowIndex = currentRows.reduce(
    (max, row) => Math.max(max, row.rowindex || 0), 0
  ) + 1;

  const newRow = {
    ...rowToCopy,
    rowindex: newRowIndex,
    jr_id: "0",
    jr_isdeleted: "0",
    showField: newRowIndex
  };

  const updatedRows = [
    ...currentRows.slice(0, arrayIndex + 1), 
    newRow,
    ...currentRows.slice(arrayIndex + 1) 
  ];

  this.setState({ pvdata: updatedRows }, () => {
    console.log("Row successfully duplicated after index", rowIndexToCopy);
  });
};

/*onRowdelete(jrld,rowindex){
	
  let r = window.confirm("Are you sure to Delete?");
		 if(r == true){
			const updatedArray = [...this.state.pvdata]; 
			
			
			
			if(updatedArray[rowindex].jr_le_id!=="")
			{				
			 updatedArray[rowindex].jr_isdeleted = 1;	
			  this.setState({pvdata: updatedArray,},()=>{});
			}else{
				alert("You can not delete this row");
				return false;
			}
		 }	
}
*/
onRowdelete(jrld, rowindex) {
    let r = window.confirm("Are you sure to Delete?");
    if (!r) return;

    const updatedArray = [...this.state.pvdata];
    const currentRow = updatedArray[rowindex];

    
    if (rowindex === 0) {
        const isFirstRowEmpty = !currentRow.jr_le_id || currentRow.jr_le_id === "";
        const secondRow = updatedArray[1];

        const isSecondRowHasContent = secondRow && secondRow.jr_le_id && secondRow.jr_le_id !== "";

        if (isFirstRowEmpty && !isSecondRowHasContent) {
            alert("You cannot delete the first empty row unless the second row has content.");
            return false;
        }
    }

    
    if (currentRow.jr_le_id && currentRow.jr_le_id !== "") {
        updatedArray[rowindex].jr_isdeleted = 1;
    } else {
        updatedArray.splice(rowindex, 1);
    }

    this.setState({ pvdata: updatedArray });
}

 ViewmoreElement= (index) => { 
 
  const updatedArray = [...this.state.pvdata];

	 
	 if(updatedArray[index].addpopupicon==="0")
	 {
updatedArray[index].addpopupicon = "1";
	 }
	 else{updatedArray[index].addpopupicon = "0";}

this.setState({pvdata: updatedArray});
 }


  render() { 
  
  if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }
return (
 
		<React.Fragment> 
	
		<div className="contenttext">
 
		<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity={this.state.errortype}
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
	  <div className="searchbox">
		<ul>
		<li>
		<p><span className="validation">*</span>Reference</p>
< TextField
            variant="outlined"
            margin="normal"
            className="txtbox"
            fullWidth
			value={this.state.jo_reference}
            id="jo_reference"
            name="jo_reference"
			onChange={this.myChangeHandler}	
          inputProps={{
    maxLength:150,
	tabIndex: "1"
  }}
 /></li>
 <li>  
<p><span className="validation">*</span>Date</p>
     <p><LocalizationProvider dateAdapter={AdapterDayjs}>
     <DemoContainer components={['DatePicker']}>
    <DatePicker
     value= {dayjs(this.state.jo_date) }
      className="txtbox" 
      onChange={this.handlejournaldate} format="MM/DD/YYYY"
	
   />  </DemoContainer>
    </LocalizationProvider></p>

</li>
<li>
<p>Description</p>
<TextField
        variant="outlined"
        margin="normal"
            className="txtbox"
            fullWidth
			value={this.state.jo_description}
            id="jo_description"
            name="jo_description"
			onChange={this.myChangeHandler}
			inputProps={{   
			tabIndex: "3"
		}}
	
		 />
		 	<span>You have used {this.state.textcountmin} of {this.state.textcountmax} characters</span>
</li>
	
</ul>

</div><div className="clear"></div>
</div>

<div className="clear"></div>
<div className="ordtbl">
<Paper >
 <TableContainer >  
 <Table stickyHeader aria-label="sticky table"> 
 
 <TableHead> 
  <TableRow>
	
 <TableCell width="15%"><b>Ledger Account</b></TableCell>     
 <TableCell width="20%"><b>Details</b></TableCell>  
 <TableCell width="10%"><b>Debit</b></TableCell> 
 <TableCell width="10%"><b>Credit</b></TableCell> 
<TableCell width="2%"></TableCell>  
<TableCell width="1%"></TableCell>  
 		 			
                      </TableRow></TableHead>
                      <TableBody>
					  
 {(this.state.pvdata).map((item,index) => {
           return ( <React.Fragment>
   {item.jr_isdeleted!==1 && (	
 <TableRow key={index} >

<TableCell>
<p><Autocomplete
      id="free-solo-demo"
       className="txtbox"
     
	inputValue={item.jr_le_id}
		   onInputChange={this.onInputLedgerChange(index)}
		   onChange={this.onTagsledgerChange(index)} 
	    value={item.ledgername}
      options={this.state.lederarrauto}
	   
      renderInput={(params) => (
        <TextField {...params} onChange={this.LedgerBind}  variant="outlined" />
      )}
      getOptionLabel={(option) => option.title || ""}
renderOption={(props, option: AcOption) => (
        <React.Fragment>
          <table width='200%' >
          
            <tbody> {option.rowindex!=="-1" &&(
              <tr {...props}>
                <td width='10%'>{option.title}</td>
         
				
              </tr> )}
			   {option.rowindex=="-1" &&(
			    <tr {...props}>
                <td width='10%' 
				
				onClick={()=>{this.Ledgeraddbox(
					
						index)}}
				
				><span className='addautoextender' ><AddIcon />{option.title}</span></td>
         
				
              </tr>
			   )}
			  
            </tbody>
          </table>
        </React.Fragment>
      )}
    /></p>
   

 </TableCell>  
 
 <TableCell>
< TextField
            variant="outlined"
            margin="normal"
            className="txtbox"
            fullWidth
			value={item.jr_details}
            id="jr_details"
            name="jr_details"
			  onChange={this.myChangeHandlerPV(index)}
	 inputProps={{
    maxLength:150
  }}
			
 />


</TableCell>
<TableCell>
< TextField
            variant="outlined"
            margin="normal"
            className="txtbox"
            fullWidth
			value={Number(item.jr_debit || 0).toFixed(2)}
            id="jr_debit"
            name="jr_debit"
			  onChange={this.myChangeHandlerPV(index)}
	
          inputProps={{
    maxLength:6
  }}
			
 />


</TableCell>
<TableCell>
< TextField
            variant="outlined"
            margin="normal"
            className="txtbox"
            fullWidth
			value={Number(item.jr_credit || 0).toFixed(2)}
            id="jr_credit"
            name="jr_credit"
			onChange={this.myChangeHandlerPV(index)}	
          inputProps={{
    maxLength:6
  }}
			
 />


</TableCell>
<TableCell  className="moreoption">
 	 
       
<InputAdornment position="center" >
                <MoreHorizIcon
                onClick={()=>{this.ViewmoreElement(index)}}
                />
              </InputAdornment>


		
<div className="EachrowAddcopyicon"><div className="journaltooltip">

 <Tooltip title="Insert row above " placement="top">
  <IconButton>
   <AddIcon className="journaladdicon" onClick={()=>{this.OnrowAddLedger(index)}}  />
  </IconButton>
</Tooltip> 


<Tooltip title="" placement="">
  <IconButton>
   <DeleteIcon  className="journaladdicon" onClick={()=>{this.onRowdelete(item.jr_le_id,index)}} />
  </IconButton>
</Tooltip>

<Tooltip title="Copy row" placement="bottom">
  <IconButton onClick={() => this.onRowCopyLedger(index)}>
    <ContentCopyTwoToneIcon className="journaladdicon" />
  </IconButton>
</Tooltip>


		
  <div className="clear"></div></div></div>
	
    
  
</TableCell>

   </TableRow>)}
 </React.Fragment>	
				);
					})}					  
  
	</TableBody>



</Table>
  </TableContainer> 
 
  </Paper>	
</div>



   <div className="salesactions">
  
   <p>
   <Button component="label"  className="frmSecondarybtn" name="st_profile"  onChange={this.onFileChange}   variant="contained"   accept="image/*;capture=camera" startIcon={<AttachmentIcon />}>
	
		Add File
		<VisuallyHiddenInput type="file"  /></Button>
		{this.state.previocn!="" && (
		<p><a href={localStorage.getItem("ISIurl")+"uploads/"+this.state.previocn} target="_blank">View</a></p>
		)}
		
		&nbsp;
		
   <Button variant="contained" disabled= {this.state.btndisabled} className="frmSecondarybtn" onClick={this.onClickSalesSave}>
	   {this.state.submitbtn}
</Button>&nbsp;
    <Button variant="contained" className="frmthirdbtn" onClick={this.onclickCancel}>
Cancel
</Button>
</p>
   </div>
   
   <div className="clear"></div>
	
  <AddLedger ref="AddLedger" id={0}   updateledger={this.updatledgerParent}/>	
  

</React.Fragment>
  );
  }

}

